import {Injectable} from '@angular/core';
import {ConfigService} from '@ngmedax/config';
import {PermissionService} from '@ngmedax/permission';
import {permission} from './simu.permission';

@Injectable()
/**
 * Simu service
 */
export class SimuService {
  /**
   * Constructor for simu service
   */
  public constructor(
    private permissionService: PermissionService,
    private config: ConfigService,
  ) {
  }

  /**
   * Returns true if single instance multiple user mode is enabled
   * Will be ignored/disabled if user has user manager permission
   *
   * @return {boolean} true if simu mode is enabled
   */
  public isSimuMode(): boolean {
    const isSimuMode = !!this.config.get('simu.mode');
    const hasUserManagerPermission = this.permissionService.isAllowed(permission.UMS_USER_CREATE)
    return isSimuMode && !hasUserManagerPermission;
  }
}
